import { useSelector } from "react-redux";
import { selectUserDetails } from "../selectors/user";
import { isAdmin } from "../util/authentication";
import { Watchlist } from "../reducer/watchList.reducer";
import { isCommunityOrReferenceType } from "../components/watchlist/WatchUtils";
import { Watchlist_Type } from "../proto/generated/watchlist";
import { selectPreviewWatchlistId } from '../selectors/watchList.ts'
export const useShouldAllowAccess = () => {
  const user = useSelector(selectUserDetails);
  const isUserAdmin = isAdmin(user?.currentUser);
  const preview = useSelector(selectPreviewWatchlistId);

  return (watchlist: Watchlist , isEnabled: boolean): boolean => {
    if (preview?.isActive) {
      return false;
    }
    if (isUserAdmin){
      if(!watchlist?.type.includes(Watchlist_Type.REFERENCE)) return true ;
      return isEnabled;
    };
    return !isCommunityOrReferenceType(watchlist); 
  };
};